import dynamic from 'next/dynamic';
import { HlsPlayerProps } from './VideoPlayerTypes';

// HlsPlayer pulls in video.js (~600 KB minified). Card previews only mount it on hover,
// so load it on demand instead of shipping it with every page that lists cards.
const LazyHlsPlayer = dynamic<HlsPlayerProps>(() => import('./HlsPlayer'), { ssr: false });

export default LazyHlsPlayer;
